function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-product-planning-5491140");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-product-planning-5491140",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M187.38,320.13 C180.5441,313.2941 169.47,313.2941 162.634,320.13 C155.7981,326.9659 155.7981,338.04 162.634,344.876 L167.759,350.001 L122.505,350.001 L122.505,385.001 L167.759,385.001 L162.6301,390.1299 C155.7942,396.9658 155.7942,408.0399 162.6301,414.8759 C166.052,418.2939 170.5285,420.0009 175.0051,420.0009 C179.4817,420.0009 183.9621,418.29 187.3801,414.872 L222.3801,379.872 C229.216,373.0361 229.216,361.962 222.3801,355.126 L187.38,320.13 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5,70 L157.5,70 L157.5,87.5 C157.5,97.1641 165.3281,105 175,105 L245,105 C254.6719,105 262.5,97.1641 262.5,87.5 L262.5,17.5 C262.5,7.8359 254.6719,0 245,0 L175,0 C165.3281,0 157.5,7.8359 157.5,17.5 L157.5,35 L17.5,35 C7.8281,35 0,42.8359 0,52.5 C0,62.1641 7.8281,70 17.5,70 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420,157.5 L105,157.5 L105,140 C105,130.3359 97.1719,122.5 87.5,122.5 L17.5,122.5 C7.8281,122.5 0,130.3359 0,140 L0,210 C0,219.6641 7.8281,227.5 17.5,227.5 L87.5,227.5 C97.1719,227.5 105,219.6641 105,210 L105,192.5 L437.5,192.5 C447.1719,192.5 455,184.6641 455,175 L455,122.5 L420,122.5 L420,157.5 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.5,0 L402.5,0 C392.8281,0 385,7.8359 385,17.5 L385,35 L280,35 L280,70 L385,70 L385,87.5 C385,97.1641 392.8281,105 402.5,105 L472.5,105 C482.1719,105 490,97.1641 490,87.5 L490,17.5 C490,7.8359 482.1719,0 472.5,0 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.5,315 L70,315 L70,245 L35,245 L35,315 L17.5,315 C7.8281,315 0,322.8359 0,332.5 L0,402.5 C0,412.1641 7.8281,420 17.5,420 L87.5,420 C97.1719,420 105,412.1641 105,402.5 L105,332.5 C105,322.8359 97.1719,315 87.5,315 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.82,212.35 L245,279.998 L367.5,349.998 L490,279.998 L376.18,212.35 C370.7972,209.2133 364.196,209.2133 358.813,212.35 L358.82,212.35 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245,297.5 L358.75,364 L358.75,490 L253.33,425.125 C248.1542,421.9414 245.0019,416.2969 245.0019,410.223 L245,297.5 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M490,297.5 L376.25,364 L376.25,490 L481.67,425.125 C486.8458,421.9414 489.9981,416.2969 489.9981,410.223 L490,297.5 Z",
  id: "Path"
})));

var SvgProductRoadmap = function SvgProductRoadmap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "490px",
    height: "490px",
    viewBox: "0 0 490 490",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductRoadmap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ProductRoadmap.c53c9777.svg";
export { ForwardRef as ReactComponent };